//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectInput from "../SelectInput/index";
export default {
  data: function data() {
    return {
      checked: true,
      GroupingList: [{
        value: '默认',
        label: '默认'
      }],
      GroupingValue: '默认',
      data: [{
        RuleValue: '最高'
      }, {
        RuleValue: '高'
      }, {
        RuleValue: '普通'
      }],
      RuleList: [{
        value: '最高',
        label: '最高'
      }, {
        value: '高',
        label: '高'
      }, {
        value: '普通',
        label: '普通'
      }, {
        value: '低',
        label: '低'
      }]
    };
  },
  components: {
    SelectInput: SelectInput
  }
};